import axios from 'axios'
import store from '@/store/index'
import { setInterceptors } from './common/interceptors'

// moblie 백엔드 기본 url
function createInstance() {
  return axios.create({
    baseURL: process.env.VUE_APP_API_URL,
  })
}

// 액시오스 초기화 함수
function createInstanceWithAuth(url) {
  const instance = axios.create({
    baseURL: `${process.env.VUE_APP_API_URL}`,
  })
  return setInterceptors(instance)
}

function weatherInstance() {
  return axios.create({
    baseURL: 'https://apis.data.go.kr/1360000/VilageFcstInfoService_2.0',
  })
}

// 인터셉터하지 않는 api 호출 및 로딩 스피너 제어
async function callApiWithSpinner(apiFunction, ...args) {
  store.commit('START_SPINNER')
  try {
    return await apiFunction(...args)
  } finally {
    store.commit('END_SPINNER')
  }
}

export { callApiWithSpinner }
export const instance = createInstance()
export const weather = weatherInstance()
export const instanceWithAuth = createInstanceWithAuth()
